<script lang="ts">
import { defineComponent, useSlots, computed } from 'vue'

export default defineComponent({
  name: 'SectionHeadingForHome',

  setup() {
    const slots = useSlots()

    const hasSlot = computed(() => {
      const v = !!slots.default && slots.default().some(vnode => vnode.children || vnode.props)
      if (!v && import.meta.env.DEV) {
        console.warn('Exception:\nSection heading slot is empty. Please provide content into the slot.')
      }
      return v
    })

    return {
      // computed
      hasSlot,
    }
  },
})
</script>

<template>
  <div class="o-heading__section">
    <h2
      v-if="hasSlot"
      class="o-heading__section--item">
      <slot />
    </h2>
  <!-- /.o-heading__section --></div>
</template>

<style lang="sass" scoped>
// object
.o-heading__section
  $gap: 1em
  display: grid
  grid-template-columns: auto $gap 1fr
  align-items: center
  margin-bottom: 1em

  &:last-child
    margin-bottom: 0

  &::after
    content: ""
    height: 1px
    display: block
    grid-column: 3 / 4
    background-image: repeating-linear-gradient(to right, $border-dark-orange, $border-dark-orange 1px, transparent 1px, transparent 4px)

  & &--item
    font:
      size: $font-xx-large
      weight: bold
</style>
